export { default } from './LoginLogo';
